export const LocationProviderQueryKeys = {
  GEOCOMPLY_INIT: (userId: string | undefined) => ['location/geoComply/init', userId],
  LOCATION_TOKEN: (userId: string | undefined, geoPermissionStatus: PermissionState) => [
    'location/geoComply/check',
    userId,
    geoPermissionStatus,
  ],
  GEO_PERMISSION_STATUS: ['location/geoLocationPermissionState'],
};

export const UserProviderQueryKeys = {
  USER_AUTH: ['userAuth'],
  USER_DETAILS: (userId?: string) => ['userDetails', userId],
  USER_SSN_STATUS: (userId?: string) => ['userSsnStatus', userId],
  USER_W9_STATUS: (userId?: string) => ['userW9Status', userId],
  USER_COHORTS: (userId?: string) => ['userCohorts', userId],
};
